module.exports = __webpack_public_path__ + "img/uil-file-graph.f67b3a2f.svg";